<!-- Modal Header -->
<div class="modal-header modal-head">
  <div class="modal-titles">
    {{'pages.dam.documenti.documenti-edit.title' | translate}}
  </div>
</div>

<!-- Modal body -->
<div class="modal-body">
  <form [formGroup]="formBuilder">
    
    <div class="row">
      <div class="col">
        <div class="m-3">
          <label for="documentModelUpdate_published" class="form-label label-fw">Pubblicato</label>
          <input type="text" id="documentModelUpdate_published" class="modal-input form-control" placeholder="Published"
            value="{{documentGetModel.published?'SI':'NO'}}" disabled>
        </div>
      </div>
      <div class="col">
        <div class="m-3">
          <label for="documentModelUpdate_publicUrl" class="form-label label-fw">
            Url Pubblico
            <a href="javascript:void(0)" [ngClass]="{'success-copy-effect': successCopyUrlClass == true}"
              class="py-0 btn" (click)="clickButtonCopyUrl()" [hidden]="!documentGetModel.published">
              <i class="far fa-copy"></i>
            </a>
            <a class="py-0 btn" [href]="fileUrlDownload" download="{{documentGetModel.filename}}">
              <i class="fas fa-download"></i>
            </a>

            <a rel="noopener" class="py-0 btn" href="{{externalLinkPublicUrl}}" target="_blank" [hidden]="!documentGetModel.published">
              <i class="fas fa-external-link-alt"></i>
            </a>
            <a rel="noopener" class="py-0 btn" href="{{documentGetModel.signedUrl}}" target="_blank" [hidden]="documentGetModel.published">
              <i class="fas fa-external-link-alt"></i>
            </a>
          </label>
          <input type="text" id="documentModelUpdate_publicUrl" class="modal-input form-control form-fw"
            placeholder="Url Pubblico" formControlName="publicurl">
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col">
        <div class="m-3">
          <label for="documentModelUpdate_name" class="form-label label-fw">Nome</label>
          <input type="text" id="documentModelUpdate_name" class="modal-input form-control"
            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}" placeholder="Nome"
            formControlName="name">
          <div class="invalid-feedback" *ngIf="formControls.name.touched">
            <span *ngIf="formControls.name.errors && formControls.name.errors?.required">
              Nome è obbligatorio
            </span>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col">
        <div class="m-3">
          <label for="documentModelUpdate_alt" class="form-label label-fw">Alt</label>
          <input type="text" id="documentModelUpdate_alt" class="modal-input form-control" placeholder="Alt"
            formControlName="alt">
        </div>
      </div>
      <div class="col">
        <div class="m-3">
          <label for="documentModelUpdate_summary" class="form-label label-fw">Summary</label>
          <input type="text" id="documentModelUpdate_summary" class="modal-input form-control" placeholder="Summary"
            formControlName="summary">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="m-3">
          <label for="documentModelUpdate_tags" class="form-label label-fw">Tags</label>
          <input type="text" id="documentModelUpdate_tags" class="modal-input form-control" placeholder="Tags"
            formControlName="tags">
        </div>
      </div>
      <div class="col">
        <div class="m-3">
          <label for="documentModelUpdate_copyright" class="form-label label-fw">Copyright</label>
          <input type="text" id="documentModelUpdate_copyright" class="modal-input form-control" placeholder="Copyright"
            formControlName="copyright">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="m-3">
          <label for="documentModelUpdate_filename" class="form-label label-fw">File name</label>
          <input type="text" id="documentModelUpdate_filename" class="modal-input form-control" placeholder="Filename"
            formControlName="filename" disabled>
        </div>
      </div>
    </div>

  </form>

  <div class="row">
    <div class="col">
      <div class="m-3">
        <label for="documentModelUpdate_createdAt" class="form-label label-fw">Creato il</label>
        <input type="text" id="documentModelUpdate_createdAt" class="modal-input form-control" placeholder="Creato il"
          value="{{documentGetModel.createdAt | date: 'dd/MM/yyyy'}}" disabled>
      </div>
    </div>
    <div class="col">
      <div class="m-3">
        <label for="documentModelUpdate_createdBy" class="form-label label-fw">Creato Da</label>
        <input type="text" id="documentModelUpdate_createdBy" class="modal-input form-control" placeholder="Creato Da"
          value="{{documentGetModel.createdBy}}" disabled>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="m-3">
        <label for="documentModelUpdate_modifiedAt" class="form-label label-fw">Modificato il</label>
        <input type="text" id="documentModelUpdate_modifiedAt" class="modal-input form-control"
          placeholder="Modificato il" value="{{documentGetModel.modifiedAt | date: 'dd/MM/yyyy'}}" disabled>
      </div>
    </div>
    <div class="col">
      <div class="m-3">
        <label for="documentModelUpdate_modifiedBy" class="form-label label-fw">Modificato Da</label>
        <input type="text" id="documentModelUpdate_modifiedBy" class="modal-input form-control"
          placeholder="Modificato Da" value="{{documentGetModel.modifiedBy}}" disabled>
      </div>
    </div>
  </div>

  <!-- Modal footer -->
  <div class="modal-foot">
    <div class="row my-3 text-center">

      <button type="submit" [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false"
        class="btn btn-fw text me-3" (click)="clickButtonSave()">Salva modifiche</button>
      <button type="button" class="btn btn-outline-fw text" (click)="cancel()">Annulla</button>

    </div>
  </div>
</div>